import { useTenantStore } from "@/state/tenant_state";
import { useRefreshSelectedTenant } from "@/hooks/useTenants";
import { MyTenantsResult } from "breuer-supercharged-sdk";
import React, { Suspense } from "react";
import { ReactNode, useEffect } from "react";
import LoaderComponent from "shared-lib/components/loader.js";

const TenantSelectionScreen = React.lazy(() => import('@/pages/tenant-selection/tenant_selection_screen'));

interface TenantPageWrapperProps {
  children: ReactNode;
}

export default function TenantPageWrapper({
  children,
}: TenantPageWrapperProps) {
  const { selectedTenant, setSelectedTenant } = useTenantStore();
  useRefreshSelectedTenant();

  // Check if current path is admin - if so, skip tenant requirement
  const currentPath = window.location.pathname;
  const isAdminPath = currentPath.startsWith('/admin');

  useEffect(() => {
    // Check localStorage for tenant ID on app load
    const storedTenantId = localStorage.getItem("x-tenant-id");
    if (storedTenantId && !selectedTenant) {
      // If we have a stored tenant ID but no selected tenant,
      // we need to load tenant details or at least set basic info
      // For now, we'll create a minimal tenant object
      const placeholderTenant: MyTenantsResult = {
        userId: "",
        tenantId: storedTenantId,
        createdAt: "",
        tenant: {
          id: storedTenantId,
          name: "Loading...",
          slug: "",
          isActive: true,
          contactEmail: "",
          createdAt: "",
          updatedAt: "",
          settings: "{}",
        },
      };
      setSelectedTenant(placeholderTenant);
    }
  }, [selectedTenant, setSelectedTenant]);

  // If this is an admin path, skip tenant requirement
  if (isAdminPath) {
    return <>{children}</>;
  }

  // If no tenant is selected and no tenant ID in localStorage, show tenant selection
  const storedTenantId = localStorage.getItem("x-tenant-id");
  if (!selectedTenant && !storedTenantId) {
    return <Suspense fallback={<LoaderComponent />}>
      <TenantSelectionScreen />
    </Suspense>;
  }

  return <>{children}</>;
}
